/**
 * 报表打印 / 导出 公共 mixin（资产负债表 / 利润表 / 现金流量表 / 季报通用）
 * 页面需要：report、reportData、accountDate，并提供 ioDimension（默认 MONTH）
 *
 * 页面模板需放：
 *   <Button size="s" icon="fa fa-print" @click="printReport">打印</Button>
 *   <DropdownMenu button @click="ioTrigger" :datas="ioMenus" size="s">导出</DropdownMenu>
 *   <Modal v-model="batchModal" ...>（见脚本插入）
 */
import moment from 'moment';
import { printTable } from './print';
import { exportXls } from './export';

const DEFAULT_SIGN = [{ name: '主管', value: '' }, { name: '记账', value: '' }, { name: '审核', value: '' }, { name: '出纳', value: '' }];

function money(v) {
	if (v == null || v === '') return '';
	const n = Number(v);
	if (isNaN(n)) return '';
	const s = Math.abs(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	return (n < 0 ? '-' : '') + s;
}

export default {
	data() {
		return {
			batchModal: false,
			batchLoading: false,
			batchStart: null,
			batchEnd: null,
			ioStep: 'month'
		};
	},
	computed: {
		ioCompany() {
			let s = (this.$store && this.$store.state) ? this.$store.state.currentAccountSets : null;
			return s ? (s.name || s.accountSetsName || '') : '';
		},
		ioTitle() {
			return this.report ? (this.report.name || '') : '';
		},
		ioDimension() {
			return this.dimension || 'MONTH';
		},
		ioPeriod() {
			if (!this.accountDate) return '';
			return moment(this.accountDate).format('YYYY年MM期');
		},
		ioMenus() {
			return [{ title: '导出当前期', key: 'exportCurrent' }, { title: '批量导出', key: 'openBatch' }];
		}
	},
	methods: {
		ioTrigger(key) {
			this[key].call(this);
		},
		/** 按期间取数（页面可覆盖） */
		ioFetch(date) {
			return Api.report.view(this.report.id, {
				accountDate: date,
				orgId: this.orgId,
				dimension: this.ioDimension
			});
		},
		/** 根据报表类型构建 head + rows */
		ioBuild(reportData) {
			const data = reportData || this.reportData || {};
			const items = this.report ? (this.report.items || []) : [];
			if (this.report && this.report.type === 1) {
				const head = ['资产', '行次', '期末余额', '年初余额', this.liabilitiesTitle || '负债和所有者权益', '行次', '期末余额', '年初余额'];
				const list = this.templateItemsRender || [];
				const rows = list.map(item => {
					const a = data[item.id] || {};
					const b = data[item.fs_id] || {};
					return [
						item.title, item.isClassified ? '' : (item.lineNum > -1 ? item.lineNum : ''),
						a.currentPeriodAmount == null ? '' : a.currentPeriodAmount,
						a.currentYearAmount == null ? '' : a.currentYearAmount,
						item.fs_title || '', item.fs_isClassified ? '' : (item.fs_lineNum > -1 ? item.fs_lineNum : ''),
						b.currentPeriodAmount == null ? '' : b.currentPeriodAmount,
						b.currentYearAmount == null ? '' : b.currentYearAmount
					];
				});
				return { head, rows, landscape: true, align: ['left', 'center', 'right', 'right', 'left', 'center', 'right', 'right'] };
			}
			const head = ['名称', '行次', '本年累计金额', '本期金额'];
			const rows = items.map(item => {
				const d = data[item.id] || {};
				return [
					item.title, item.isClassified ? '' : (item.lineNum > -1 ? item.lineNum : ''),
					d.currentYearAmount == null ? '' : d.currentYearAmount,
					d.currentPeriodAmount == null ? '' : d.currentPeriodAmount
				];
			});
			return { head, rows, landscape: false, align: ['left', 'center', 'right', 'right'] };
		},
		printReport() {
			if (!this.report || !this.report.items) {
				this.$Message('暂无数据可打印');
				return;
			}
			const b = this.ioBuild();
			printTable({
				title: this.ioTitle,
				company: this.ioCompany,
				period: this.ioPeriod,
				head: b.head,
				rows: b.rows.map(r => r.map((c, i) => (i > 0 && typeof c === 'number') ? money(c) : c)),
				align: b.align,
				landscape: b.landscape,
				sign: DEFAULT_SIGN
			});
		},
		exportCurrent() {
			if (!this.report || !this.report.items) {
				this.$Message('暂无数据可导出');
				return;
			}
			const b = this.ioBuild();
			exportXls({
				name: `${this.ioTitle}_${this.ioPeriod}`,
				sheets: [{ name: this.ioTitle.substring(0, 31), head: b.head, rows: b.rows, widths: [260, 60, 140, 140] }]
			});
		},
		openBatch() {
			this.batchStart = this.accountDate;
			this.batchEnd = this.accountDate;
			this.batchModal = true;
		},
		doExportBatch() {
			if (!this.batchStart || !this.batchEnd) {
				this.$Message('请选择导出期间');
				return;
			}
			let start = moment(this.batchStart), end = moment(this.batchEnd);
			if (start.isAfter(end)) {
				this.$Message('开始期间不能大于结束期间');
				return;
			}
			let isQuarter = this.ioStep === 'quarter';
			let step = isQuarter ? 'quarter' : 'month';
			let periods = [];
			let cur = start.clone();
			while (!cur.isAfter(end) && periods.length < 36) {
				periods.push(cur.clone());
				cur.add(1, step);
			}
			if (!periods.length) {
				this.$Message('请选择导出期间');
				return;
			}
			if (periods.length >= 36) {
				this.$Message('一次最多导出36期，超出部分将被忽略');
			}
			this.batchLoading = true;
			const tasks = periods.map(p => this.ioFetch(p.format('YYYY-MM-DD')));
			Promise.all(tasks).then(results => {
				const sheets = [];
				results.forEach((res, i) => {
					const b = this.ioBuild((res && res.data) || {});
					const label = this.ioStep === 'quarter'
						? periods[i].format('YYYY年[第]Q[季度]')
						: periods[i].format('YYYY年MM期');
					sheets.push({
						name: label,
						head: b.head,
						rows: b.rows,
						widths: [260, 60, 140, 140]
					});
				});
				exportXls({ name: `${this.ioTitle}_${periods[0].format('YYYYMM')}-${periods[periods.length - 1].format('YYYYMM')}`, sheets: sheets });
				this.batchLoading = false;
				this.batchModal = false;
			}).catch(() => {
				this.batchLoading = false;
				this.$Message('导出失败，请重试');
			});
		}
	}
};
